<template>
  <div class="min-h-screen bg-white overflow-hidden relative">
    <!-- Background Blur Effects -->
    <!-- <div class="absolute inset-0 pointer-events-none -z-[100]">
      <div class="absolute -bottom-20 left-0 w-screen h-3/4 bg-gradient-to-t from-yellow-200/60 to-transparent mix-blend-multiply filter blur-3xl"></div>
      <div class="absolute -top-20 right-0 w-80 h-1/2 bg-gradient-to-t from-yellow-200/60 to-transparent rounded-full mix-blend-multiply filter blur-3xl"></div>
    </div> -->
    <div class="container mx-auto">
      <div class="flex justify-center items-center min-h-screen py-8">
        <!-- Logo Section -->
        <div class="w-full max-w-md">
          <Transition name="fade-slide">
            <div v-if="showContent" class="text-center mb-8">
              <img src="/images/CargoLink.svg" alt="CargoLink" class="h-8 mx-auto mb-3" />
              <p class="text-gray-500">Seamless Shipping Solutions</p>
            </div>
          </Transition>
          <!-- Content Section -->
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const showContent = ref(false)

onMounted(() => {
  showContent.value = true
})
</script>

<style scoped>
.fade-slide-enter-active {
  transition: all 0.5s ease-out;
}

.fade-slide-leave-active {
  transition: all 0.3s ease-in;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
